export const categories = [
  { slug: 'pingce', name: '平台评测', icon: 'ri-star-line', description: '专业评测各大博彩平台，助您选择正规可靠的网站' },
  { slug: 'youhui', name: '优惠活动', icon: 'ri-gift-line', description: '最新博彩平台优惠信息、首存红利、返水活动汇总' },
  { slug: 'peilv', name: '赔率分析', icon: 'ri-line-chart-line', description: '深度赔率分析，帮助您做出更明智的投注决策' },
  { slug: 'anquan', name: '安全指南', icon: 'ri-shield-check-line', description: '博彩安全知识科普，保护您的资金与隐私安全' },
  { slug: 'zixun', name: '行业资讯', icon: 'ri-newspaper-line', description: '全球博彩行业最新动态与政策变化解读' },
  { slug: 'celve', name: '策略技巧', icon: 'ri-lightbulb-line', description: '专业博彩策略与实战技巧分享，提升您的胜率' },
];

export const featuredPlatforms = [
  {
    id: 'p1',
    name: '澳门金沙娱乐城',
    rating: 4.8,
    logo: 'https://readdy.ai/api/search-image?query=Golden%20casino%20logo%20design%20with%20elegant%20Chinese%20style%20typography%2C%20luxurious%20gold%20on%20dark%20red%20background%2C%20minimalist%20and%20sophisticated%20brand%20identity%2C%20professional%20gaming%20company%20emblem%2C%20clean%20vector%20style%20with%20subtle%20glow%20effect&width=200&height=200&seq=platform-logo-01&orientation=squarish',
    bonus: '首存赠送100% 最高888元',
    features: ['24小时客服', '秒速提现', '体育电竞'],
    url: '#',
  },
  {
    id: 'p2',
    name: '永利国际博彩',
    rating: 4.7,
    logo: 'https://readdy.ai/api/search-image?query=Luxurious%20gaming%20platform%20logo%20with%20crown%20motif%20and%20deep%20red%20gold%20accents%2C%20elegant%20Chinese%20calligraphy%20inspired%20brand%20mark%2C%20premium%20casino%20identity%20design%2C%20clean%20background%20with%20subtle%20pattern&width=200&height=200&seq=platform-logo-02&orientation=squarish',
    bonus: '新会员注册即送68元体验金',
    features: ['真人视讯', '丰富游戏', '高额返水'],
    url: '#',
  },
  {
    id: 'p3',
    name: '星耀博彩平台',
    rating: 4.6,
    logo: 'https://readdy.ai/api/search-image?query=Diamond%20star%20shaped%20gaming%20brand%20logo%20design%20with%20gold%20and%20burgundy%20premium%20color%20scheme%2C%20luxurious%20casino%20identity%2C%20modern%20minimalist%20style%20with%20sparkle%20effects%2C%20clean%20dark%20background&width=200&height=200&seq=platform-logo-03&orientation=squarish',
    bonus: '每周返水高达1.2%',
    features: ['体育博彩', '电子竞技', 'VIP专属'],
    url: '#',
  },
  {
    id: 'p4',
    name: '银河娱乐城',
    rating: 4.5,
    logo: 'https://readdy.ai/api/search-image?query=Galaxy%20themed%20luxury%20casino%20logo%20with%20golden%20stars%20and%20elegant%20Chinese%20typography%2C%20premium%20dark%20red%20background%2C%20sophisticated%20brand%20identity%20for%20gaming%20platform%2C%20clean%20minimalist%20vector%20design&width=200&height=200&seq=platform-logo-04&orientation=squarish',
    bonus: '首存三连送 总额最高2888元',
    features: ['多种支付', '快速到账', '手机APP'],
    url: '#',
  },
  {
    id: 'p5',
    name: '鼎盛博彩国际',
    rating: 4.4,
    logo: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20tripod%20vessel%20inspired%20casino%20logo%20design%2C%20gold%20and%20crimson%20color%20palette%2C%20premium%20gaming%20brand%20identity%2C%20elegant%20and%20trustworthy%20visual%20style%2C%20clean%20minimalist%20vector%20art&width=200&height=200&seq=platform-logo-05&orientation=squarish',
    bonus: 'VIP专享 月返水无上限',
    features: ['直播赌场', '彩票游戏', '24h出款'],
    url: '#',
  },
  {
    id: 'p6',
    name: '乐天博彩平台',
    rating: 4.3,
    logo: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20gaming%20platform%20logo%20with%20playful%20yet%20elegant%20design%2C%20warm%20gold%20and%20deep%20red%20color%20scheme%2C%20Chinese%20market%20focused%20brand%20identity%2C%20clean%20professional%20vector%20style&width=200&height=200&seq=platform-logo-06&orientation=squarish',
    bonus: '每日签到领金币 连签奖励翻倍',
    features: ['棋牌游戏', '电子游艺', '红包福利'],
    url: '#',
  },
];

export const latestArticles = [
  {
    slug: '2024-bocai-pingtai-paiming',
    title: '2024年最权威博彩平台排名TOP10：正规可靠平台推荐',
    excerpt: '我们综合评测了超过50家在线博彩平台，从安全性、赔付速度、游戏种类、用户口碑等多个维度，为您精选出2024年最值得信赖的十大博彩平台。无论您是新手还是资深玩家，这份排名都将助您做出明智选择。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20casino%20interior%20with%20golden%20chandeliers%20and%20warm%20ambient%20lighting%2C%20sophisticated%20gaming%20atmosphere%2C%20dark%20wood%20furnishings%2C%20premium%20hotel%20lobby%20style%2C%20professional%20photography%20with%20soft%20bokeh%20background&width=800&height=500&seq=article-cover-01&orientation=landscape',
    category: 'pingce',
    date: '2024-12-15',
    readTime: '8分钟',
    author: '博彩网编辑部',
  },
  {
    slug: 'xinren-bocai-zhinan',
    title: '博彩新手入门完全指南：从注册到首投的全流程解析',
    excerpt: '初次接触在线博彩不知从何下手？本指南将带您从零开始，详细讲解账户注册、充值方式、游戏规则、首投策略等关键环节，让您快速上手，避免常见陷阱，安全开启博彩之旅。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20laptop%20and%20notebook%2C%20warm%20golden%20accent%20lighting%2C%20clean%20and%20professional%20atmosphere%2C%20learning%20and%20research%20concept%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20photography&width=800&height=500&seq=article-cover-02&orientation=landscape',
    category: 'anquan',
    date: '2024-12-12',
    readTime: '12分钟',
    author: '博彩网编辑部',
  },
  {
    slug: 'zhuqiu-peilv-fenxi',
    title: '足球博彩赔率深度分析：如何读懂赔率背后的信息',
    excerpt: '赔率不仅仅是数字，更蕴含着丰富的信息。本文将教您如何解读足球博彩中的各种赔率类型，分析赔率变化背后的逻辑，掌握欧赔与亚盘的转换技巧，助您在投注中占据信息优势。',
    cover: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20atmosphere%20with%20analytical%20data%20overlay%2C%20warm%20stadium%20lights%2C%20sports%20analytics%20concept%2C%20dark%20green%20field%20with%20golden%20evening%20light%2C%20professional%20sports%20photography%20style&width=800&height=500&seq=article-cover-03&orientation=landscape',
    category: 'peilv',
    date: '2024-12-10',
    readTime: '10分钟',
    author: '数据分析师李明',
  },
  {
    slug: 'bocai-youhui-pandian',
    title: '12月博彩优惠活动大盘点：这些福利不容错过',
    excerpt: '年末各大博彩平台纷纷推出重磅优惠活动，我们为您整理了12月最新最全的博彩优惠信息，包括首存红利、返水加码、节日专属活动等，帮您抓住每一个薅羊毛的机会。',
    cover: 'https://readdy.ai/api/search-image?query=Luxurious%20gift%20boxes%20and%20golden%20ribbons%20on%20elegant%20dark%20background%2C%20festive%20promotional%20atmosphere%2C%20warm%20golden%20and%20red%20color%20palette%2C%20premium%20product%20photography%20with%20sparkle%20effects%2C%20celebration%20concept&width=800&height=500&seq=article-cover-04&orientation=landscape',
    category: 'youhui',
    date: '2024-12-08',
    readTime: '6分钟',
    author: '优惠情报员小王',
  },
  {
    slug: 'dianzi-jingji-bocai',
    title: '电子竞技博彩崛起：新一代玩家的投注新选择',
    excerpt: '随着电子竞技产业的蓬勃发展，电竞博彩正成为增长最快的博彩细分市场。本文分析电竞博彩的发展现状、主流游戏项目、与传统体育博彩的差异，以及未来的发展趋势。',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20neon%20lighting%20and%20large%20screens%2C%20competitive%20gaming%20atmosphere%2C%20dark%20background%20with%20colorful%20LED%20accents%2C%20professional%20esports%20event%20photography%2C%20crowded%20stadium%20with%20dramatic%20lighting&width=800&height=500&seq=article-cover-05&orientation=landscape',
    category: 'zixun',
    date: '2024-12-05',
    readTime: '7分钟',
    author: '电竞观察员张伟',
  },
  {
    slug: 'zijin-anquan-guanli',
    title: '博彩资金安全管理：保护您的账户与资金的最佳实践',
    excerpt: '资金安全是博彩体验的基础。本文详细介绍了博彩账户的安全设置方法、资金管理原则、防诈骗技巧，以及遭遇问题时的应对策略，全方位守护您的博彩资金安全。',
    cover: 'https://readdy.ai/api/search-image?query=High%20security%20vault%20door%20with%20digital%20lock%20and%20golden%20accents%2C%20luxurious%20bank%20interior%2C%20warm%20ambient%20lighting%2C%20safety%20and%20protection%20concept%2C%20professional%20institutional%20photography%20style%2C%20confident%20and%20secure%20atmosphere&width=800&height=500&seq=article-cover-06&orientation=landscape',
    category: 'anquan',
    date: '2024-12-02',
    readTime: '9分钟',
    author: '安全顾问陈强',
  },
];

export const heroStats = [
  { label: '评测平台', value: '200+' },
  { label: '活跃用户', value: '50万+' },
  { label: '原创文章', value: '1500+' },
  { label: '行业经验', value: '10年+' },
];

export const faqItems = [
  {
    question: '如何判断一个博彩平台是否正规可靠？',
    answer: '判断平台是否正规可以从以下几个方面入手：查看平台是否持有合法的博彩牌照（如菲律宾PAGCOR、马耳他MGA等），了解平台的运营历史和口碑评价，检查网站是否使用SSL加密，客服响应是否及时专业，以及提现是否顺畅。博彩网对所有推荐平台均进行了严格的审核评估。',
  },
  {
    question: '新手应该如何选择适合自己的博彩平台？',
    answer: '新手选择平台时建议优先考虑以下因素：平台的正规性和安全性、新用户优惠力度、游戏种类的丰富程度、充值提现的便捷性、中文客服支持质量等。建议先从小额投注开始，熟悉平台操作和游戏规则后再逐步增加投入。',
  },
  {
    question: '在线博彩充值提现安全吗？有哪些支付方式？',
    answer: '正规博彩平台都会采用银行级别的加密技术保障交易安全。主流支付方式包括银行转账、第三方支付、加密货币等。建议选择支持多种支付方式的平台，并注意查看各支付渠道的手续费和到账时间。提现前务必完成实名认证以确保顺利出款。',
  },
  {
    question: '博彩平台的红利和优惠活动有哪些注意事项？',
    answer: '参与优惠活动时需特别注意以下几点：仔细阅读活动规则和条款，了解流水倍数要求（即需要投注多少倍才能提现），注意活动的有效期限，确认是否有游戏限制，以及是否存在最高提现金额限制。理性看待优惠，不要为了红利而盲目投注。',
  },
  {
    question: '博彩网的文章评测是否客观公正？',
    answer: '博彩网始终坚持客观、公正、专业的评测原则。我们的评测团队由资深博彩行业分析师组成，评测过程基于真实体验和多维度数据对比。我们不接受任何平台的付费排名要求，所有评测结果均基于实际表现，确保为用户提供最真实可靠的参考信息。',
  },
];

export const aboutInfo = {
  brandName: '博彩网',
  brandIntro: '博彩网成立于2014年，是国内领先的专业博彩资讯与导航平台。十年来，我们始终秉持"专业、客观、安全"的服务理念，为数百万用户提供最新、最全面的博彩平台评测、优惠活动、赔率分析和安全指南。',
  mission: '我们的使命是帮助每一位博彩爱好者找到正规、可靠、适合自己的博彩平台，在保障资金安全和个人隐私的前提下，享受高质量的在线博彩娱乐体验。',
  features: [
    { title: '专业评测', desc: '200+平台深度评测', icon: 'ri-medal-line' },
    { title: '实时更新', desc: '24小时资讯同步', icon: 'ri-time-line' },
    { title: '安全保障', desc: '严格筛选正规平台', icon: 'ri-shield-check-line' },
    { title: '用户至上', desc: '50万+用户信赖之选', icon: 'ri-user-heart-line' },
  ],
};